var px = 0;
var sortType = '1';
var fundType = '01';
var topList = '01';
$(function () {
    setHotRecommend();
    getFundType();
});

function getFundType() {
    toApi_toAcCg('S15Q705', { dictCode: 'fund_column_type', state: '1' }, function (data) {
        if (data && data.jsonData && data.jsonData.length > 0) {
            var fundTypeList = data.jsonData;
            var html = "";

            // <a href="javascript:void(0)" onclick="getTopList('01')" class="active" id="t01">股票型<i></i></a>
            $('#tab').html(function () {
                for (var i = 0; i < fundTypeList.length; i++) {
                    html += '<a href="javascript:void(0)" onclick="getTopList(\'' + fundTypeList[i].valueCode + '\')" id="t' + fundTypeList[i].valueCode + '">' + fundTypeList[i].valueName + '</a>';
                }
                html += '<a href="javascript:void(0)" onclick="getTopList(\'00\')" id="t00">自选</a>';
                return html;
            })
            var fundCode = getParamsByName("fundCode");
            if (isNull(fundCode)) {
                //股票型 01
                getTopList(fundTypeList[0].valueCode);
                $('t' + fundTypeList[0].valueCode).addClass('active');
            } else {
                $('#search').val(fundCode);
                search();
            }
        }
    })
}

function getTopList(fundType) {
    if (fundType == '04') {
        sortType = '9';
    } else {
        sortType = '1';
    }
    px = 0;
    topList = fundType;
    getList(1, fundType, sortType, px, '');
}



function getSortList(sort) {

    if (px == 0) {
        px = 1;
    } else {
        px = 0;
    }
    sortType = sort;
    getList(1, fundType, sort, px, '');
}
function search() {
    var keyword = $('#search').val();
    var pageno = 1;
    var fundType = 'ALL';
    var sortType = '1';
    var navSort = '0';
    ['01', '02', '04', '05', '03', '09', '11', '12', '00'].forEach(function (e) {
        $('#t' + e).removeClass('active');
    });

    $('#div_list').html('<table class="deal-list checkbox-wrap sorting" cellpadding="0" cellspacing="0" id="list"></table> <div class="page" id="page"></div>');


    toApi('fundproductlist.tml?pageno=' + pageno + '&pagesz=10&versionFlag=1&fundType=' + fundType + '&sortType=' + sortType + '&navSort=' + navSort + '&keyword=' + encodeURIComponent(keyword) + '&fundSubType=0',

        function (data) {

            var list1 = [];
            var list2 = [];
            var list3 = [];

            data.infos = handleFundListData(data.infos);
            data.infos.forEach(function (e) {



                if (e.fundType === '04') {
                    list2.push(e);
                } else {
                    list1.push(e);
                }

            });

            if (list1.length === 0 && list2.length === 0) {

                $('#div_list').html('<p class="text3">抱歉！没有找到您要的信息</p>');
            }
            var htmlList = template('tpl_search', { "list1": list1, "list2": list2, "list3": list3 });
            $('#list').html(htmlList);
        }
    );
}


function getList(pageno, _fundType, sortType, navSort, keyword) {

    fundType = _fundType;
    $('#div_list').html('<table class="deal-list checkbox-wrap sorting" cellpadding="0" cellspacing="0" id="list"></table> <div class="page" id="page"></div>');

    ['01', '02', '04', '05', '03', '09', '11', '12', '00'].forEach(function (e) {
        if (e == fundType) {
            $('#t' + e).addClass('active');
        } else {
            $('#t' + e).removeClass('active');
        }
    });

    toApi('fundproductlist.tml?pageno=' + pageno + '&pagesz=10&versionFlag=1&fundType='
        + fundType + '&sortType=' + sortType + '&navSort=' + navSort + '&keyword=' + keyword + '&fundSubType=0',

        function (data) {

            data.infos = handleFundListData(data.infos);
            if (topList == '00') {//已关注
                var list4 = [];//已关注非货币基金
                var list5 = [];//已关注货币基金
                data.infos.forEach(function (e) {
                    if (e.fundType === '04') {
                        list5.push(e);
                    } else {
                        list4.push(e);
                    }
                });
                var htmlList = '';
                if (list4.length > 0) {
                    var h1 = template('tpl_row', { "list": list4, "fundType": fundType, 'sortType': sortType, 'navSort': navSort, 'topList': topList });
                    htmlList += h1;
                }
                if (list5.length > 0) {
                    var h2 = template('tpl_row', { "list": list5, "fundType": '04', 'sortType': sortType, 'navSort': navSort, 'topList': topList });
                    htmlList += h2;
                }
                if (isNull(htmlList) || htmlList.length === 0) {
                    htmlList = '<p class="text3">暂无记录</p>';
                }
                $('#list').html(htmlList);
            } else {//其他
                var htmlList = template('tpl_row', { "list": data.infos, "fundType": fundType, 'sortType': sortType, 'navSort': navSort, 'topList': topList });
                $('#list').html(htmlList);
            }
        }
    );
}

function handleFundListData(fundList) {
    var result = [];
    var personalFundCode = getPersonalFundCode();

    fundList.forEach(function (e) {

        e.riskLevelCn = '-';
        if (e.riskLevel == '0') {
            e.riskLevelCn = '低风险';
            e.ecolor = "gray";
        } else if (e.riskLevel == '1') {
            e.riskLevelCn = '中低风险';
            e.ecolor = "gray";
        } else if (e.riskLevel == '2') {
            e.riskLevelCn = '中风险';
            e.ecolor = "yellow";
        } else if (e.riskLevel == '3') {
            e.riskLevelCn = '中高风险';
            e.ecolor = "red";
        } else if (e.riskLevel == '4') {
            e.riskLevelCn = '高风险';
            e.ecolor = "red";
        }

        if (e.state === '1') {
            // e.nav = Number(e.faceValue).toFixed(4);
            e.btnName = '认购';
            e.avgreturnDay = null;
            e.avgreturnMonth = null;
            e.avgreturnQuarter = null;
            e.avgreturnHalfyear = null;
            e.avgreturnYear = null;
        } else {
            e.btnName = '买入';
        }

        var rateAndColor = handleFundRate(e.avgreturnDay);
        e.avgreturnDay = rateAndColor.rate;
        e.avgreturnDayColor = rateAndColor.color;

        rateAndColor = handleFundRate(e.avgreturnMonth);
        e.avgreturnMonth = rateAndColor.rate;
        e.avgreturnMonthColor = rateAndColor.color;

        rateAndColor = handleFundRate(e.avgreturnQuarter);
        e.avgreturnQuarter = rateAndColor.rate;
        e.avgreturnQuarterColor = rateAndColor.color;

        rateAndColor = handleFundRate(e.avgreturnHalfyear);
        e.avgreturnHalfyear = rateAndColor.rate;
        e.avgreturnHalfyearColor = rateAndColor.color;

        rateAndColor = handleFundRate(e.avgreturnYear);
        e.avgreturnYear = rateAndColor.rate;
        e.avgreturnYearColor = rateAndColor.color;

        if (!isNull(e.changeDate)) {
            e.changeDate = e.changeDate.substring(0, 4) + '-' + e.changeDate.substring(4, 6) + '-' + e.changeDate.substring(6, 8);
        } else {
            e.changeDate = '-';
            e.color = 'cello';
        }

        if (!isNull(e.nav)) {
            e.nav = toThousands(e.nav, 4);
        }
        if (!isNull(e.fundIncome)) {
            e.fundIncome = toThousands(e.fundIncome, 4);
        }
        if (!isNull(e.yield)) {
            e.yield = e.yield * 100;
            var rateAndColor = handleFundRate(e.yield, 4);
            e.yield = rateAndColor.rate;
            e.yieldColor = rateAndColor.color;
        }
        if (e.fundCode !== personalFundCode) {
            result.push(e);
        }
    });
    return result;
}

function handleFundRate(fundRate, len) {
    var rateAndColor = {};
    len = isNull(len) ? 2 : len;
    if (!isNull(fundRate)) {
        fundRate = parseFloat(fundRate).toFixed(len);
        if (fundRate > 0) {
            fundRate = '+' + fundRate;
            rateAndColor.color = 'red';
        } else if (fundRate < 0) {
            rateAndColor.color = 'green';
        } else {
            rateAndColor.color = 'cello';
        }
        fundRate += '%';
    } else {
        fundRate = '-';
        rateAndColor.color = 'cello';
    }
    rateAndColor.rate = fundRate;
    return rateAndColor;
}


function toPage(index, pages, type) {

    if (type == 1) {
        if (index + 1 <= pages) {
            getList(index + 1, fundType, sortType, px, '');
        }
    } else if (type == -1) {
        if (index - 1 >= 1) {
            getList(index - 1, fundType, sortType, px, '');
        }
    } else {
        var num = 1;
        try {
            num = parseInt($('#toPage').html());
        } catch (err) {
            num = 1;
        }
        if (num > 0 && num <= pages) {
            getList(num, fundType, sortType, px, '');
        }
    }
}

function gotoFundBuy() {
    // {
    //     fundCode: outLineFundCode,
    //     productInfoId: loadValue("summaryID", false),
    //     transCode: "020", // 认申购020，定投039，转换036
    //     ptfCode: 0
    // }
    if (!loadValue("unScrollbottom", false)) {
        alert("请先完成全文阅读");
        return;
    }
    removeValue("unScrollbottom", false);
    $("#pupFundOutline").hide();
    var outLineFundCode = loadValue("outLineFundCode", false);
    removeValue("outLineFundCode", false);
    var S092019params = {
        fundSummaryVos: fundSummaryArr,
        source: 'fundSupermarket'
    };
    toApi_toAc("S092019", S092019params, function () {
        window.location.href = window.phURL + 'fund/fundBuy.html?fundCode=' + outLineFundCode;
    }, '', '', function (err) {
        window.location.href = window.phURL + 'fund/fundBuy.html?fundCode=' + outLineFundCode;
    });
}

function readNext(){
    console.log(222222,itemArr)
    //循环对象，找到下一个未读的展示，如果找不到，则代表全部已读，执行之后的业务逻辑
    noReadArr= itemArr.filter(function(val){
        return val.hasRead == false
    })
    console.log(33333,noReadArr)
    if(noReadArr.length==0){
        $("#pupFundOutline").hide();
        var outLineFundCode = loadValue("outLineFundCode", false);
        removeValue("outLineFundCode", false);
        var S092019params = {
            fundSummaryVos: fundSummaryArr,
            source: 'fundSupermarket'
        };
        toApi_toAc("S092019", S092019params, function () {
            window.location.href = window.phURL + 'fund/fundBuy.html?fundCode=' + outLineFundCode;
        }, '', '', function (err) {
            window.location.href = window.phURL + 'fund/fundBuy.html?fundCode=' + outLineFundCode;
        });

    }else{
        // nowIndex = noReadArr[0].eq;
        console.log(nowIndex);
    
        if (itemArr[nowIndex].hasRead) {
          if (parseInt(nowIndex) + 1 == itemArr.length) {
            nowIndex = 0;
          } else {
            nowIndex++;
          }
          $(".outLine_box").eq(nowIndex).show().siblings().hide();
          $(".titleItem")
            .eq(nowIndex)
            .addClass("active")
            .siblings()
            .removeClass("active");
          return;
        }
        itemArr[nowIndex].hasRead = true;
    
        hasReadNum = itemArr.filter(function (val) {
          return val.hasRead == true;
        }).length;
        if (parseInt(hasReadNum) < itemArr.length) {
          $(".nextBtn2").text(
            "我已阅读并知悉(" + hasReadNum + "/" + itemArr.length + ")"
          );
        } else {
            readNext();
        }
    
        if (parseInt(nowIndex) + 1 == itemArr.length) {
          nowIndex = 0;
        } else {
          nowIndex++;
        }
        $(".outLine_box").eq(nowIndex).show().siblings().hide();
          $(".titleItem")
            .eq(nowIndex)
            .addClass("active")
            .siblings()
            .removeClass("active");
      }
}

